/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type ServiceType = typeof ServiceType[keyof typeof ServiceType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ServiceType = {
  SAFEGUARD: 'SAFEGUARD',
  HUB: 'HUB',
  CASH_ACCOUNT: 'CASH_ACCOUNT',
  FEE: 'FEE',
  FUNDING: 'FUNDING',
  OPERATIONAL: 'OPERATIONAL',
} as const;
